import { Smartphone } from "lucide-react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { authClient } from "@/lib/auth-client";
import { queryClient } from "@/utils/trpc";
import { AuthShell } from "./auth-shell";

export const WORKER_WEB_BLOCKED_QUERY_PARAM = "worker_web_blocked";

export function WorkerWebAccessGate() {
  const navigate = useNavigate();
  const hasStartedSignOutRef = useRef(false);

  useEffect(() => {
    if (hasStartedSignOutRef.current) {
      return;
    }

    hasStartedSignOutRef.current = true;
    queryClient.clear();

    void authClient
      .signOut()
      .catch((error) => {
        console.error("Failed to sign out blocked worker session:", error);
      })
      .finally(() => {
        const searchParams = new URLSearchParams({
          [WORKER_WEB_BLOCKED_QUERY_PARAM]: "1",
        });

        navigate(`/sign-in?${searchParams.toString()}`, { replace: true });
      });
  }, [navigate]);

  return (
    <AuthShell
      title="Web access isn't available for workers"
      description="Download the OS04 mobile app from the App Store or Google Play for sign-ins, forms, and day-to-day worker tasks."
    >
      <Alert variant="warning">
        <Smartphone />
        <AlertTitle>Use the mobile app instead</AlertTitle>
        <AlertDescription>
          Your account is being signed out because worker accounts use the
          mobile app instead of the web dashboard.
        </AlertDescription>
      </Alert>
    </AuthShell>
  );
}
